import { daysAgo, WEEK_DAYS } from './familyWeek.ts';

export type TryNext = { kind: 'book'; id: string } | { kind: 'game'; topic: string } | null;

/**
 * Try this next (kid engagement PRD F3), by fixed rules in order: the newest
 * kid book not yet finished; else the first of `games` (already in the start
 * screen's order) not played in the last seven local days; else nothing.
 */
export function tryNext(
  books: readonly { id: string; number: number; finished: boolean }[],
  talks: readonly { startedAt: string; topic?: string | null }[],
  games: readonly string[],
  now: Date,
): TryNext {
  const unread = books.filter((b) => !b.finished).sort((a, b) => b.number - a.number)[0];
  if (unread) return { kind: 'book', id: unread.id };
  const played = new Set(
    talks
      .filter((t) => {
        const n = daysAgo(t.startedAt, now);
        return n >= 0 && n < WEEK_DAYS;
      })
      .map((t) => t.topic),
  );
  const game = games.find((g) => !played.has(g));
  return game ? { kind: 'game', topic: game } : null;
}
